import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { AxiosHttpClient } from "../../../../../services/AxiosHttpService";
import { ButtonMui } from "../../../../../styles/ButtonMui";

interface ConfirmDeleteDialogProps {
  popupActive: string;
  setPopupActive: (open: string) => void;
  getLegalDocuments: () => void;
}

const DeleteLegalDocument = ({
  popupActive,
  setPopupActive,
  getLegalDocuments,
}: ConfirmDeleteDialogProps) => {
  const deleteLegalDocument = () => {
    AxiosHttpClient.delete("api/v1/docuveritas/legal-documents/" + popupActive)
      .then(() => {
        getLegalDocuments();
        setPopupActive("");
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const [isLoading, setIsLoading] = React.useState(false);

  const { t } = useTranslation();

  return (
    <Dialog open={popupActive !== ""} onClose={() => setPopupActive("")}>
      <DialogTitle>{t("DELETE_LEGAL_DOCUMENT_DIALOG_TITLE")}</DialogTitle>
      <DialogContent>
        <Typography>{t("DELETE_LEGAL_DOCUMENT_CONFIRM_TEXT")}</Typography>
      </DialogContent>
      <DialogActions>
        <ButtonMui loading={isLoading} onClick={() => setPopupActive("")}>
          {t("DELETE_LEGAL_DOCUMENT_BUTTON_CANCEL")}
        </ButtonMui>
        <ButtonMui
          loading={isLoading}
          onClick={deleteLegalDocument}
          variant="contained"
          color="error"
        >
          {t("DELETE_LEGAL_DOCUMENT_BUTTON_DELETE")}
        </ButtonMui>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteLegalDocument;
